import React, { useState, useContext } from "react"
import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import RichText from "../../../../components/text/RichText"
import { StoreContext } from "../../../../context/store"
import * as queryString from "query-string"
import Breadcrumb from "../../../../components/ui/breadcrumb/Breadcrumb"
export default function SanityProduct({ data: { product }, location }) {
  const { flashprice } = queryString.parse(location.search)
  const [index, setIndex] = useState(0)

  const images = product.image

  const changeImage = (e, i) => {
    e.preventDefault()
    setIndex(i)
  }
  const { toggleCart, addToCart } = useContext(StoreContext)

  const [qty, setQty] = useState(1)
  const getPrice = flashprice
    ? flashprice
    : product.discountPrice
    ? product.discountPrice
    : product.price
  const disPrice = flashprice ? flashprice : product.discountPrice
  const discount = parseInt((product.price - disPrice / product.price) * 100)
  const onClickCart = (e, p) => {
    const product = {
      id: p._id,
      title: p.title,
      price: getPrice,
      vendor: p.vendor.title,
      image: images[0].asset.gatsbyImageData,
      qty: Number(qty),
      slug: `/${p.subcategory?.category?.slug?.current}/${p?.subcategory?.slug?.current}/${p?.slug?.current}`,
    }
    e.preventDefault()
    addToCart(product)
    toggleCart(true)
  }

  const updateQuantity = e => {
    e.preventDefault()
    setQty(Number(e.target.value))
  }

  const notInStock = product.stock <= 0 || product.currentlyNotInStock

  return (
    <div className="p-4">
      <Breadcrumb
        subSlug={product.subcategory.slug.current}
        cateSlug={product.subcategory.category.slug.current}
        subcategory={product.subcategory.title}
        category={product.subcategory.category.title}
        proSlug={product.slug.current}
        product={product.title}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6">
        <div className="flex flex-col md:flex-row -mx-4">
          <div className="md:flex-1 px-4">
            <div>
              <div className="  rounded-lg  mb-4">
                {images && (
                  <GatsbyImage
                    image={images[index].asset.gatsbyImageData}
                    alt="our product"
                    objectFit="contain"
                    className="h-[400px] rounded-lg  mb-4 flex items-center justify-center"
                  ></GatsbyImage>
                )}
              </div>

              <div className="flex -mx-2 mb-4">
                {images &&
                  images.map((img, i) => {
                    return (
                      <div className="flex-1 px-2" key={i}>
                        <button
                          onClick={e => changeImage(e, i)}
                          className={` ${
                            index === i && "ring-2 ring-indigo-300 ring-inset"
                          } focus:outline-none w-full rounded-lg h-24 md:h-32 bg-gray-100 flex items-center justify-center`}
                        >
                          <GatsbyImage
                            image={img.asset.gatsbyImageData}
                            alt="our product"
                            className="h-24 md:h-32"
                            objectFit="cover"
                          ></GatsbyImage>
                        </button>
                      </div>
                    )
                  })}
              </div>
            </div>
          </div>
          <div className="md:flex-1 px-4">
            <h2 className="mb-2 leading-tight tracking-tight font-bold text-gray-800 text-2xl md:text-3xl">
              {product.title}
            </h2>
            <p className="text-gray-500 text-sm">
              By{" "}
              <a href="/" className="text-primary hover:underline">
                {product.vendor.title}
              </a>
            </p>

            <div className="flex items-center space-x-4 my-4">
              <div>
                <div className="rounded-lg bg-gray-100 flex py-2 px-3">
                  <span className="text-black mr-1 mt-1">৳</span>
                  <span className="font-bold text-black text-3xl">
                    {getPrice}
                  </span>
                </div>
              </div>
              {discount < 100 && (
                <div className="flex-1">
                  <p className="text-primary text-xl font-semibold">
                    Save -{discount}%
                  </p>
                  <p className="text-gray-400 text-sm">
                    Inclusive of all Taxes.
                  </p>
                </div>
              )}
            </div>

            <div className="flex py-4 space-x-4">
              <div className="relative">
                <div className="text-center left-0 pt-2 right-0 absolute block text-xs uppercase text-gray-400 tracking-wide font-semibold">
                  Qty
                </div>
                <select
                  onChange={e => updateQuantity(e)}
                  className="cursor-pointer appearance-none rounded-xl border border-gray-200 pl-4 pr-8 h-14 flex items-end pb-1"
                >
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                </select>

                <svg
                  className="w-5 h-5 text-gray-400 absolute right-0 bottom-0 mb-2 mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M8 9l4-4 4 4m0 6l-4 4-4-4"
                  />
                </svg>
              </div>

              <button
                onClick={e => onClickCart(e, product)}
                disabled={notInStock}
                type="button"
                className="h-14 disabled:hover:bg-gray-400 px-6 py-2 font-semibold rounded-xl bg-black hover:bg-primary text-white"
              >
                Add to Cart
              </button>
            </div>

            {notInStock && (
              <div className="text-primary">Currently Not in Stock</div>
            )}
            <div className="my-4 p-2 rounded-md border w-auto bg-gray-100 hover:bg-black hover:text-white transition-colors duration-200">
              <ul className="list-disc mx-4 px-2">
                <li>Inside Dhaka home delivery - 80 Tk</li>
                <li>Outside Dhaka courier service - 130 Tk</li>
              </ul>
            </div>
            {product.description &&
              product.description.map(child => {
                child.markDefs = []
                return (
                  <div className="mt-5" key={child._key}>
                    <RichText
                      key={child._key}
                      blocks={child}
                      className="prose"
                    />
                  </div>
                )
              })}
          </div>
        </div>
      </div>
    </div>
  )
}

export const query = graphql`
  query ($id: String!) {
    product: sanityProduct(id: { eq: $id }) {
      title
      _id
      discountPrice
      discountPriceList
      stock
      currentlyNotInStock
      tags
      vendor {
        title
      }
      tags
      subcategory {
        slug {
          current
        }
        category {
          title
          slug {
            current
          }
        }
        title
      }
      slug {
        current
      }
      price
      image {
        asset {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      description {
        _key
        _type
        style
        list
        children {
          text
          _type
          _key
          marks
        }
      }
    }
  }
`
